module.exports = __webpack_public_path__ + "static/img/gsjj2.a8f57ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/gsjj2.png
// module id = ZM7l
// module chunks = 0